import { List } from 'immutable';
//@ts-expect-error Untyped import
import attributionTouchPoints from './attributionTouchPoints';
//@ts-expect-error Untyped import
import contactCreateAttribution from './contactCreateAttribution';
//@ts-expect-error Untyped import
import dealCreateAttribution from './dealCreateAttribution';
//@ts-expect-error Untyped import
import deviceTypes from './deviceTypes';
//@ts-expect-error Untyped import
import feedback from './feedback';
//@ts-expect-error Untyped import
import funnel from './funnel';
//@ts-expect-error Untyped import
import idAggregation from './idAggregation';
import inboundDb from './inboundDb';
//@ts-expect-error Untyped import
import sequenceEnrollments from './sequenceEnrollments';
//@ts-expect-error Untyped import
import sequenceSenderScore from './sequenceSenderScore';
import simple from './simple';
//@ts-expect-error Untyped import
import socialChannels from './socialChannels';
//@ts-expect-error Untyped import
import socialPosts from './socialPosts';
//@ts-expect-error Untyped import
import unified from './unified';
import unifiedEvents from './unifiedEvents';
import externalDataType from './externalDataType';
import unifiedEventsQL from './unifiedEventsQl';

// Order matters here: generateDrilldownReport uses the first supported generator
export const drilldownGenerators = List([funnel, feedback, socialChannels, socialPosts, sequenceSenderScore, unified, deviceTypes, idAggregation, attributionTouchPoints, contactCreateAttribution, dealCreateAttribution, sequenceEnrollments, inboundDb, unifiedEvents, unifiedEventsQL, externalDataType, simple]);
export const findSupportedGeneratorAsync = (report, dataTypeModule, {
  checkColumnSupport = false,
  column = ''
} = {}) => {
  const isSupportedPromise = generator => Promise.resolve(generator.isSupported(report, dataTypeModule)).then(isSupported => checkColumnSupport ? isSupported || generator.isSupportedColumn && generator.isSupportedColumn(report, column, dataTypeModule) : isSupported);
  const recursiveFindSupportedGenerator = ([generator, ...rest]) => generator ? isSupportedPromise(generator).then(isSupported => isSupported ? generator : recursiveFindSupportedGenerator(rest)) : Promise.resolve(undefined);
  return recursiveFindSupportedGenerator(drilldownGenerators.toJS());
};
export const hasSupportedGeneratorAsync = (report, dataTypeModule) => findSupportedGeneratorAsync(report, dataTypeModule).then(generator => generator !== undefined);